import {
  DetailParams,
  TableColumn, TablePaginationParams, TableParams,
  TableRow,
  TableValueAction,
  TableValueType
} from '../../../shared/models';
import {formatValue} from '../../../shared/helpers';
import {Chacra} from './chacras.model';
import {Cultivo} from "../cultivos";

export interface ChacrasTableColumn extends TableColumn {
  literalFormat?: (v: any) => string;
  actionFormat?: (chacra: Chacra, sources?: ChacrasTableSources) => TableValueAction;
}

export interface ChacrasTableParams extends TableParams{
  columns: ChacrasTableColumn[];
  chacras: Chacra[];
  sources?: ChacrasTableSources;
}

export interface ChacrasListParams {
  chacra: DetailParams;
  suelo?: DetailParams[];
}

export enum ChacrasTableAction {
  GO_TO_MAP = 'GotoVistaMapa',
  GO_TO_ADMIN = 'GotoVistaAdministrativa',
  SELECCIONAR = 'Select'
}

export interface ChacrasTableSources {
  rolId: string;
  personaId: string;
  cultivos: Cultivo[];
}

export interface ChacrasTableActionValue {
  action: ChacrasTableAction;
  chacra: Chacra;
}

export interface ChacrasTableRowSource {
  chacra: Chacra;
}

export function resolveChacrasTableCellValue(
  chacra: Chacra,
  column: ChacrasTableColumn,
  sources: ChacrasTableSources
): string | string[] {
  const names = column.name.split('.');
  if (names.length > 1) {
    let os: any[] = [];
    switch (names[0]) {
      case 'cultivo':
        os =  sources.cultivos.filter(c => c.cultivoId === chacra.cultivo);
        break;
      case 'suelos':
        os = chacra.suelos;
        break;
      case 'chacra':
        if(chacra.chacra && chacra.chacra.chacras)
          os = chacra.chacra.chacras;
        break;
      case 'padron':
        if(chacra.padron && chacra.padron.padrones)
          os = chacra.padron.padrones;
        break;
    }
    const vs: string[] = [];
    let v: string[];
    const attrs = names[1].split('+');
    for (const o of os) {
      v = [];
      for (const attr of attrs) {
        if (!o || !o.hasOwnProperty(attr)) {
          continue;
        }
        v.push(formatValue(o[attr], column.literalFormat));
      }
      vs.push(v.join(', '));
    }
    return column.type === TableValueType.LIST ? vs : vs.join(' ');
  }
  return formatValue(chacra[column.name], column.literalFormat);
}

export function createChacrasTableRow(
  chacra: Chacra,
  columns: ChacrasTableColumn[],
  sources: ChacrasTableSources
): TableRow {
  const row: TableRow = {
    __source__: chacra
  };
  for (const column of columns) {
    switch (column.type) {
      case TableValueType.ACTION:
        row[column.name] = column.actionFormat
          ? column.actionFormat(chacra, sources)
          : { value: column.name, text: column.name, icon: 'bomb' };
        break;
      case TableValueType.LIST:
      case TableValueType.LITERAL:
        row[column.name] = resolveChacrasTableCellValue(chacra, column, sources);
        break;
    }
  }
  return row;
}

export function hasGeometryToLink(chacra: Chacra){
  if(chacra.chacra && chacra.chacra.chacras && chacra.chacra.chacras.length > 0)
    return true;
  if(chacra.padron && chacra.padron.padrones && chacra.padron.padrones.length > 0)
    return true;
  return false;
}

export const CHACRASTABLE_COLUMNS_ACTIONS_DEFAULT: ChacrasTableColumn[] = [
  {
    type: TableValueType.ACTION,
    name: ChacrasTableAction.GO_TO_MAP,
    label: '',
    sort: false,
    filter: false,
    actionFormat: (chacra: Chacra, sources) => {
      if(hasGeometryToLink(chacra))
        return {
          value: ChacrasTableAction.GO_TO_MAP,
          text: 'Ver en Mapa',
          icon: 'map'
        };
      return null;
    }
  },
  // {
  //   type: TableValueType.ACTION,
  //   name: ChacrasTableAction.GO_TO_ADMIN,
  //   label: '',
  //   sort: false,
  //   filter: false,
  //   actionFormat: _ => ({
  //     value: ChacrasTableAction.GO_TO_ADMIN,
  //     text: 'Ver detalles',
  //     icon: 'clipboard-list'
  //   })
  // },
];


export const CHACRASTABLE_COLUMNS_DATA_DEFAULT: ChacrasTableColumn[] = [
  {
    type: TableValueType.LITERAL,
    name: 'rendimientoId',
    label: 'ID Registro',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'geometriaId',
    label: 'ID Geometría',
    sort: true,
    filter: true
  },
  // {
  //   type: TableValueType.LITERAL,
  //   name: 'chacra.ChacraId',
  //   label: 'Geometría Chacra',
  //   sort: true,
  //   filter: true
  // },
  // {
  //   type: TableValueType.LITERAL,
  //   name: 'padron.PadronId',
  //   label: 'Geometría Padron',
  //   sort: true,
  //   filter: true
  // },
  {
    type: TableValueType.LITERAL,
    name: 'productorNombre',
    label: 'Nombre del productor',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'productorDocumento',
    label: 'Documento (RUT o CI)',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'superficieCosechada',
    label: 'Superficie cosechada',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'cultivo.cultivoNombre',
    label: 'Cultivo',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'rendimiento',
    label: 'Rendimiento (Kg/ha)',
    sort: true,
    filter: true
  },
  {
    type: TableValueType.LITERAL,
    name: 'estadoDesc',
    label: 'Estado',
    sort: true,
    filter: true
  },
];
